import Header from '../../../../../component/common/layout/Header';
import LeftSidebar from '../../../../../component/common/layout/LeftSidebar';
import VariableSubHeader from '../../../../../component/common/layout/VariableSubHeader';
import iicon from '../../../../../assets/images/i-icon.png';
import Svg from '../../../../../component/common/Svg';
import Button from "../../../../../core/Button";
import Tooltip from "../../../../../core/Tooltip";
import Switch from "../../../../../core/Switch";
import Input from "../../../../../core/Inputs/DefaultInput";
import classnames from "clsx";
import { EditText, EditTextarea } from 'react-edit-text';
import Axios from "axios";
import 'react-edit-text/dist/index.css';
import React, { useState, useEffect } from 'react';
import VariableSidebar from '../../../../../component/common/layout/VariableSidebar';
import LeftSidebarNew from '../../../../../component/common/layout/LeftSidebarNew';
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader';
import SubHeader from '../../../../../component/common/layout/SubHeader';
import { Link } from 'react-router-dom';
import useVerifySurveyId from '../../../../../hooks/verifySurveyId';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getLeadGenVariable } from '../../../../../store/actions/variableAction';
import NestedMenuToggle from '../../../settings/NestedMenuToggle';
import { useTranslation } from 'react-i18next';

export default function Index(props) {
  //==> STATES <==
  const { view, color, pos, isOpen } = props;
  const survey_id = useVerifySurveyId()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();

  //Selectors
  const leadGenData = useSelector((state => state?.variables?.leadGenData))
  const { survey_name } = useSelector((state) => state.permissionsData)


  //==> EFFECTS <==
  useEffect(() => {
    if (survey_id) {
      dispatch(getLeadGenVariable(survey_id))
    }
  }, [survey_id, dispatch]);

  return (
    <div className='d-flex flex-column main-outer-wrapper main-site-wrapper language-page bg-white'>
      <SurveyListHeader />
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <SurveyListSidebar />
        <div id="content" className="flex-grow-1 dashboard-page-outer d-flex flex-column">
          <SubHeader />
          <div className="d-flex variable-pg-wrapper flex-grow-1">
            <VariableSidebar />
            <div className="flex-grow-1 variable-pg-content">
              <div className="survey-main-container">
                <div className="page-content-wrap variables-main-container p-0">
                  {/* {console.log(process.env.REACT_APP_NODE_API_URL+`survey/getLeadGenVar?survey_id=`)} */}
                  <div className="main-sec-wrap">
                    <div className='pagesRow varPg'>
                      <div className="page-heading">
                        {/* breadcrumbs here */}
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/admin/survey/list">{t('survey.title')}</Link></li>
                            <li className="breadcrumb-item"><Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link></li>
                            <li className="breadcrumb-item"><Link to={`/admin/survey/create/lead-gen-variables?survey_id=${survey_id}`}>{t('survey.variable.heading')}</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><strong>{t('survey.variable.heading1')}</strong></li>
                          </ol>
                        </nav>
                        <div className="d-flex align-items-start">
                          <div className="mt-2">
                            <NestedMenuToggle />
                          </div>
                          <div className="flex-grow-1 ps-3 ps-lg-0">
                            <h1 className='mb-0 mb-lg-3'>{t('survey.variable.heading1')} <Tooltip
                              view={view}
                              color='primary'
                              content="Lead-gen variables"
                              position='top'
                              isOpen={isOpen ? isOpen : null}
                              className='black-tooltip  '
                            >
                              <Button view="outlined" className="action-btn custom-action copy ms-2 color-dark" text=""><Svg name="variable" /></Button>
                            </Tooltip></h1>
                            <p>{t('survey.variable.text1')}</p>

                          </div>
                        </div>
                        {/* breadcrumbs ends here */}
                      </div>

                      <div className="leadGenvar">
                        {
                          leadGenData.length > 0 ? leadGenData?.map((variable, index) => {
                            return (<span className='me-2 mb-2' key={index}>{variable?.su_name}</span>
                            )
                          }) : t('survey.variable.nodata')
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
